"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _eventemitter = _interopRequireDefault(require("eventemitter3"));
class IpcBroadcastChannel extends _eventemitter.default {
  init() {
    try {
      // Privacy settings in firefox 104~ block broadcast channels in iframes
      this.bc = new BroadcastChannel('app-ipc');
      this.bc.onmessage = this.onmessage.bind(this);
    } catch {
      // catch
    }
  }
  send(msg) {
    if (this.bc) {
      this.bc.postMessage(msg);
    }
  }
  onmessage(msg) {
    this.emit('message', msg);
  }
}
class IpcLocalStorage extends _eventemitter.default {
  init() {
    window.addEventListener('storage', this.onmessage.bind(this));
  }
  send(msg) {
    localStorage.setItem('app-ipc', JSON.stringify(msg));
    localStorage.removeItem('app-ipc');
  }
  onmessage(msg) {
    if (msg.key === 'app-ipc' && msg.newValue) {
      try {
        let parsedMsg = {
          data: JSON.parse(msg.newValue)
        };
        this.emit('message', parsedMsg);
      } catch (e) {
        this.emit('error');
      }
    }
  }
}
var _default = exports.default = window.BroadcastChannel ? new IpcBroadcastChannel() : new IpcLocalStorage();
window._app_exports = window._app_exports || {};
if(!window._app_exports["libs"]) window._app_exports["libs"] = {};
window._app_exports["libs"]["IPC"]
window._app_exports.libs.IPC = exports.default ? exports.default : exports;
